  
import * as React from 'react'

import { ReactComponent as CrossTimes } from '@/assets/icons/editor/cross-times.svg'

import './styles.sass'
import FromSelect from '../FromSelect'
import DraftManagerService from '@/app-domains/messages/draft/service/DraftManager.service'
import { ReactComponent as PaperClipIcon } from '@/assets/icons/paper-clip-icon.svg'

export default function MobileHeaderSection (props) {
  // eslint-disable-next-line
  const [canDelete, setCanDelete] = React.useState(!!props.draft?.id || false)

  // eslint-disable-next-line
  async function discardDraft () {
    setCanDelete(false)
    props.setShouldEditOnModal(false)
    await props.discardDraft()
  }

  return (
    <div className='message-modal-header'>
      <div className='message-modal-header-container'>
        <div className='close-option' onClick={props.onClose}>
          <CrossTimes />
        </div>
        <div className='message-modal-header-from'>
          <div className='from-box-section'>
            <FromSelect
              draft={props.draft}
              defaultDomain={props.defaultDomain}
              isMobile={true}
            />
          </div>
        </div>
        <div className='message-modal-header-send'>
          <PaperClipIcon onClick={() => DraftManagerService.sendMessageInstantly()}/>
        </div>
      </div>
    </div>
  )
}
